import axios from 'axios';
import { CONFIG } from '@/constants/config';
import { makeUrlWithLang } from '@/utils/helpers';

export const restClient = (lang: string) => {
  const baseURL = makeUrlWithLang({
    protocol: CONFIG.protocol || '',
    host: CONFIG.host || '',
    path: '/',
    lang,
  });

  return axios.create({
    baseURL,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
};
